// import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import RaindropCard from "../raindrop-card/raindrop-card.tsx";
import RaindropClickable from "../raindrop-clickable/raindrop-clickable.tsx";

const NimbusLinkCard = ({
  title = "Search Organisations",
  to = "#",
  icon = "fa-clock",
  onClick = () => {},
}) => {
  const navigate = useNavigate();
  return (
    <RaindropClickable
      onClick={() => {
        navigate(to);
      }}
    >
      <RaindropCard>
        <div className="flex flex-col items-center justify-center w-40 h-40">
          <i className={`fas ${icon} text-3xl`}></i>

          <div className="text-center text-xs">{title}</div>
        </div>
      </RaindropCard>
    </RaindropClickable>
  );
};

export default NimbusLinkCard;
